import { render, staticRenderFns } from "./chinaMap.vue?vue&type=template&id=2facee61&scoped=true"
import script from "./chinaMap.vue?vue&type=script&lang=js"
export * from "./chinaMap.vue?vue&type=script&lang=js"
import style0 from "./chinaMap.vue?vue&type=style&index=0&id=2facee61&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2facee61",
  null
  
)

export default component.exports